
// Actions
const PREFIX = 'calculus/energy/';

export const SET_ENERGY  = PREFIX + 'SET_ENERGY';
export const ENERGY  = PREFIX + 'ENERGY';
export const ENERGY_ITEM_TYPE = 'energy';

import {
  ADD,
  PATCH,
  REMOVE,
} from './settings';

const INITIAL_STATE = {
  loading: true,
  data: []
};

import {
  SET_CUSTOMS_ITEMS,
  PATCH_CUSTOMS_ITEMS,
  REMOVE_CUSTOMS_ITEMS,

  parseItem,
  parseItems
} from './customs';

import {
  USER_LOG_OUT
} from '../user';

// Reducer
export default function reducer(state = { ...INITIAL_STATE }, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case SET_CUSTOMS_ITEMS:
      return {
        ...state,
        data: [
          ...state.data,
          ...parseItems(payload.data, ENERGY_ITEM_TYPE)
        ]
      };


    case PATCH_CUSTOMS_ITEMS:
      console.log('PATCH_CUSTOMS_ITEMS', payload);
      return {
        ...state,
        data: state.data.map( item => {
          if(!item.custom) return item;
          const patchItem = payload.data.find( o => {
            return o.id === item.uuid;
          });

          if(patchItem) return parseItem(patchItem, ENERGY_ITEM_TYPE);
          return item;
        })
      };

    case REMOVE_CUSTOMS_ITEMS:
      console.log('REMOVE_CUSTOMS_ITEMS ', payload);
      return {
        ...state,
        data: state.data.filter( o => {
          if(o.custom) {
            const found = payload.data.findIndex( item => {
              return item.id === o.uuid;
            });
            if(found != -1) return false;
          }
          return true;
        })
      };

    case SET_ENERGY:
      return {
        ...state,
        data: payload,
        loading: false
      };
      case ADD:
        if(payload.type != ENERGY) {
          return state;
        }
        return {
          ...state,
          data: [
            ...state.data,
            payload.item
          ]
        };

      case PATCH:
        if(payload.type != ENERGY) {
          return state;
        }
        return {
          ...state,
          data: state.data.map( item => {
            if(item.Nid === payload.item.Nid) {
              return payload.item;
            }
            return item;
          })
        };

      case REMOVE:
        if(payload.type != ENERGY) {
          return state;
        }

        const index = state.data.findIndex( (item) => {
          if(item.Nid === payload.id) {
            return true;
          }
        });

        return {
          ...state,
          data: [
            ...state.data.slice(0, index),
            ...state.data.slice(index + 1)
          ]
        };

      case USER_LOG_OUT:
        return {
          ...state,
          data: state.data.filter( item => {
            return !item.custom;
          })
        };

    default:
      return state;
  }
}

// Action Creators
export function setEnergy(payload) {
  return {
    type: SET_ENERGY,
    payload: payload
  };
}
